var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.263,
    height: 18.263,
    viewBox: "0 0 18.263 18.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(0.725 0.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M.406.406l16,16",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#4f505e",
    strokeLinecap: "square",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_Copy",
    "data-name": "Line Copy",
    d: "M3.406.406l-16,16",
    transform: "translate(13 0)",
    fill: "none",
    stroke: "#4f505e",
    strokeLinecap: "square",
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0b6a4276efe597a618d19d84905e84e5.svg";
export { ForwardRef as ReactComponent };